// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"561":"89b759ed","1250":"fa88f8bd","9059":"80b4bb3a"}[chunkId] + ".chunk.css";
};